import React from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import { Button } from '@els/els-react--button';

import './ConfirmationEmailSentDialog.scss';

function ConfirmationEmailSentDialog(props) {
  const { email, selfClose } = props;

  return (
    <GeneralDialogLayout
      {...props}
      className="registration-confirmation-dialog"
      size="md"
      layoutType="nothing"
      movable={false}
      header={<h4>Registration confirmation</h4>}
      headerClassName="registration-confirmation-dialog__header rx-border-none"
      footer={
        <div className="els-btn-group-right">
          <Button type="primary" size="small" className="e2e-registration-confirmation-email-sent" onClick={selfClose}>
            Got it
          </Button>
        </div>
      }
      footerClassName="rx-border-none">
      <div className="registration-confirmation-dialog__text">
        A confirmation email has been sent to {email}. Click on the link in the email to complete registration process.
      </div>
    </GeneralDialogLayout>
  );
}

ConfirmationEmailSentDialog.propTypes = {
  email: PropTypes.string,
  selfClose: PropTypes.func.isRequired,
};

export default ConfirmationEmailSentDialog;
